import React, { Component } from 'react';
import moment from 'moment';
import Icon from 'components/Icon/Icon.react';
import Tooltip from 'rc-tooltip';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import { Chart } from 'lib/charts/frappe-charts.esm.js';
import { jsonEqual, numeral, nanoSecondsFormat } from 'lib/helpers';
import styles from './Charts.scss';


const rect = small => `<rect x="${small ? -19 : -30}" y="-30" dy="0" rx="3" class="rrm sashiDoTooltipRect ${small ? 'small' : null}"/>`;
const text = (text = 'Billing Date') => `<text x="0" y="-16" font-size="10px" text-anchor="middle" class="rrm sashiDoTooltipText">${text}</text>`;
const arrow = () => '<polygon class="rrm sashiDoTooltipArrow" points="0,0 8,0 4,4" />';
const svgMonth = (text, y) => `<text x="0" y="${y}" font-style="italic" font-size="9px" font-weigth="600" text-anchor="middle" class="rrm sashiDoTooltipTextMonth">(${text})</text>`;

export default class BarChart extends Component {
  constructor(props) {
    super(props);

    this.loader = null;
    this.root = null;
    this.chart = null;

    this.handleDataSelect = this.handleDataSelect.bind(this);
    this.formatXLabels = this.formatXLabels.bind(this);
    this.formatYLabels = this.formatYLabels.bind(this);
  }

  componentDidMount() {
    this.chartBuilder(this.props);
  }


  componentWillReceiveProps(nextProps) {
    if (!jsonEqual(this.props.data, nextProps.data)) {
      this.loader.classList.add('metricsLoaderShow');
      this.chartBuilder(nextProps);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps && this.props === nextProps) {
      return false;
    }

    return true;
  }

  componentWillUnmount() {
    this.chart.unbindWindowEvents();
  }

  chartBuilder(props) {
    const {
      data, stacked, dataFormat, unit, segmentTime,
    } = props;

    const valuesOverPoints = false;

    if (!data) {
      return null;
    }

    const tooltipOptions = {
      formatTooltipY: (d) => {
        if (dataFormat === 'nanoSecondsFormat') {
          return nanoSecondsFormat(d);
        }
        return `${numeral(d, dataFormat)} ${unit ? `<span>${unit}</span>` : ''}`;
      },
    };

    const barOptions = { stacked };

    this.chart = new Chart(this.root, {
      ...props, data, dataFormat, tooltipOptions, barOptions, valuesOverPoints,
    });


    if (!this.chart && !this.parent) return null;

    setTimeout(() => {
      this.formatXLabels();
      this.formatYLabels();
      setTimeout(() => {
        if (this.loader) {
          this.loader.classList.remove('metricsLoaderShow');
        }
      }, 200);
    }, 2000);

    return null;
  }

  formatXLabels() {
    if (!this.chart && !this.parent) return;

    const {
      segmentTime, billingDate, stacked,
    } = this.props;
    let format = 'MMM';

    if (segmentTime === '30') {
      format = 'DD';
    }

    if (this.parent) {
      [].forEach.call(this.parent.querySelectorAll('.rrm'), (e) => {
        e.parentNode.removeChild(e);
      });
    }

    const labels = this.parent.getElementsByClassName('x axis')[0].getElementsByTagName('text');

    if (labels) {
      Array.from(labels).forEach((element, index) => {
        const label = this.props.data.labels[index];

        if (this.props.dataFormat === 'nanoSecondsFormat') {
          element.textContent = label;
        }
        else {
          const newLabel = moment(label).format(format);

          if (segmentTime === '30') {
            const elDate = moment(element.dataset.date).format('YYYY-MM-DD');
            const rootElement = element.parentNode;

            if (elDate === billingDate) {
              element.previousSibling.style.stroke = 'rgba(0, 0, 0, 0.4)';
              rootElement.insertAdjacentHTML('beforeend', `${rect()}${text()}${arrow()}`);
            }

            // if(index === 29) {
            //   element.previousSibling.style.stroke = 'rgba(0, 0, 0, 0.4)';
            //   rootElement.insertAdjacentHTML('beforeend', `${rect(true)}${text('Today')}${arrow()}`);
            // }

            if (newLabel === '01' || index === 0) {
              const month = moment(label).format('MMM');

              rootElement.insertAdjacentHTML('beforeend', `${svgMonth(month, stacked ? 200 : 240)}`);
            }

            element.textContent = moment(label).format('DD');
          }
          else {
            element.textContent = moment(label).format('MMM');
          }
        }

        element.style.opacity = '1';
      });
    }

    if (segmentTime === '12') {
      const ds = this.parent.getElementsByClassName(`dataset-${stacked ? 1 : 0}`)[0].getElementsByTagName('text');
      if (ds) {
        Array.from(ds).forEach((element) => {
          element.textContent = numeral(element.textContent, this.props.dataFormat);
          element.style.opacity = '1';
        });
      }
    }
  }

  formatYLabels() {
    if (!this.chart && !this.parent) return;
    const labels = this.parent.getElementsByClassName('y axis')[0].getElementsByTagName('text');

    if (labels) {
      Array.from(labels).forEach((element) => {
        if (this.props.dataFormat === 'nanoSecondsFormat') {
          if (!element.dataset.value) {
            element.dataset.value = element.textContent;
          }
          element.textContent = nanoSecondsFormat(element.dataset.value);
        }
        else {
          element.textContent = numeral(element.textContent, this.props.dataFormat);
          // TODO
          element.style.textTransform = 'uppercase';
        }

        element.style.opacity = '1';
      });
    }
  }

  handleDataSelect(event) {
    return this.props.onSelect && this.props.onSelect({
      index: event.index,
      label: event.label,
      values: event.values,
    });
  }

  render() {
    const { customLegend, title } = this.props;

    return (
      <section className={[styles.graph, title ? styles.withTitle : ''].join(' ')}>
        <div className={styles.wrapper}>
          <div className={styles.graphHolder}>
            <div className={styles.g}>
              <div ref={parent => (this.parent = parent)} className={['charts', this.props.onSelect ? 'is_navigable' : null].join(' ')}>
                {
                  (title && !this.props.segmentTypeComponent && !this.props.segmentTypeComponent) &&
                    <div className="h">
                      <h2 className="title">
                        {title}
                        {
                          this.props.tooltip &&
                            <Tooltip placement="right" overlay={this.props.tooltip} overlayClassName={styles.rcTooltip} arrowContent={<div className="rc-tooltip-arrow-inner" />}>
                              <span><Icon name="icon-info" width={14} height={14} colored /></span>
                            </Tooltip>
                        }
                      </h2>
                      {
                        this.props.desc &&
                          <h3 className="desc">{this.props.desc}</h3>
                      }
                    </div>
                }
                <div ref={root => (this.root = root)} />

                {
                  customLegend &&
                    <div className={styles.customLegend}>
                      <div className={styles.colorGreen}>Complete</div>
                      <div className={styles.colorRed}>Failed</div>
                      <div className={styles.colorGray}>Cancelled</div>
                    </div>
                }

              </div>
            </div>
            {
              <div className={styles.segment}>
                <div className={styles.segmentType}>
                  {this.props.segmentTypeComponent}
                </div>
                <div className={styles.segmentTime}>
                  {this.props.segmentTimeComponent}
                </div>
              </div>
            }
          </div>
        </div>
        <div className={[styles.loader, 'metricsLoaderShow'].join(' ')} ref={r => (this.loader = r)}>
          <LoaderDots />
        </div>
      </section>
    );
  }
}
